"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BufferIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M2 4.194L8 .968l6 3.226-6 3.174-6-3.174z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.929 7L8 9.069 12.114 7l1.918.965L8 11 2.032 7.965 3.93 7z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.896 10.6L8 12.881l4.082-2.281L14 11.66 8 15l-6-3.34 1.896-1.06z"
  })))
});
BufferIcon.displayName = 'BufferIcon';
var _default = exports.default = BufferIcon;